import React, { Suspense, lazy } from 'react';
import './App.css';
import './buttons.css';
import ReactGA from 'react-ga4';

import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import Loader from './Util/Loader/Loader';
import PageMiss from './404/404';

const Dashboard = lazy(() => import(/* webpackChunkName: "Dashboard" */ './Dashboard/Dashboard'));

const Login = lazy(() => import(/* webpackChunkName: "login" */ './Login/Login'));

const LandingPage = lazy(() => import(/* webpackChunkName: "LandingPage" */ './LandingPage/LandingPage'));

const Registration = lazy(() => import(/* webpackChunkName: "Register" */ './Registration/Registration'));

const Profile = lazy(() => import(/* webpackChunkName: "Profile" */ './Profile/Profile'));

const AppliedJobs = lazy(() => import(/* webpackChunkName: "AppliedJobs" */ './AppliedJobs/AppliedJobs'));

const Brands = lazy(() => import(/* webpackChunkName: "AppliedJobs" */ './Brands/Brands'));

const Dine = lazy(() => import(/* webpackChunkName: "AppliedJobs" */ './Dine/Dine'));

const Entertainment = lazy(() => import(/* webpackChunkName: "AppliedJobs" */ './Entertainment/Entertainment'));

const Offer = lazy(() => import(/* webpackChunkName: "AppliedJobs" */ './Offer-Packages/Offer'));

const Events = lazy(() => import(/* webpackChunkName: "AppliedJobs" */ './Events/Events'));

const Services = lazy(() => import(/* webpackChunkName: "AppliedJobs" */ './Concierge-Services/Services'));

const CrownMap = lazy(() => import(/* webpackChunkName: "AppliedJobs" */ './Crown-Map/CrownMap'));

const Contact = lazy(() => import(/* webpackChunkName: "AppliedJobs" */ './Contact/Contact'));

const theme = createTheme({
  palette: {
    primary: {
      main: '#181818',
    },
    secondary: {
      main: '#e31e32',
    },
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }

  componentDidMount() {
    // Initialize GA4
    ReactGA.initialize("G-Z624QD3Y43");

    // Track first page load
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: document.title,
    });

    // Track subsequent route changes
    this.customHistory.listen((location) => {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname,
        title: document.title,
      });
    });
  }

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }
          >
            <Switch>
              <Route exact path="/" component={LandingPage} />
              <Route exact path="/retail" component={Brands} />
              <Route exact path="/food-court" component={Dine} />
              <Route exact path="/entertainment" component={Entertainment} />
              <Route exact path="/offer-packages" component={Offer} />
              <Route exact path="/events" component={Events} />
              <Route exact path="/services" component={Services} />
              <Route exact path="/crown-map" component={CrownMap} />
              <Route exact path="/contact" component={Contact} />
              <Route path="/login" component={Login} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/register" component={Registration} />
              <Route path="/profile" component={Profile} />
              <Route path="/applied-jobs" component={AppliedJobs} />
              <Route component={PageMiss} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;